import firebase from "../../app/config/firebase";

export const getUnassigned = () => {
    const firestore = firebase.firestore();
    return firestore.collection("leads").where("status", "==", "Unassigned").get();
};
export const logout = () => {
    return firebase.auth().signOut();
};
